export const referral = {
  name: 'bob',
  type: 'referral',
};

export const referralWithEmail = {
  name: 'carol',
  type: 'referral',
  email: 'carol@carol.com',
};

export const adminReferral = {
  name: 'carol',
  type: 'admin',
  email: 'carol@carol.com',
};
